export function getType(value) {
  return /no hub access/i.test(value)
    ? 'red'
    : /hub access (allowed|granted)/i.test(value)
    ? 'orange'
    : 'grey'
}
